// First-party CWZ analytics tracker (lightweight, no third-party deps).
import { API } from "@/lib/api";

const VID_KEY = "cz_vid";
const SID_KEY = "cz_sid";
const ATTR_KEY = "cz_attr";

function uid() {
  return "x" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

function getVisitorId() {
  let v = localStorage.getItem(VID_KEY);
  if (!v) { v = uid(); localStorage.setItem(VID_KEY, v); }
  return v;
}

function getSessionId() {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) { s = uid(); sessionStorage.setItem(SID_KEY, s); }
  return s;
}

function detectDevice() {
  const w = window.innerWidth;
  if (w < 640) return "mobile";
  if (w < 1024) return "tablet";
  return "desktop";
}

function captureContext() {
  const params = new URLSearchParams(window.location.search);
  const existing = (() => { try { return JSON.parse(sessionStorage.getItem(ATTR_KEY) || "null"); } catch { return null; } })();
  const ctx = existing || {
    landing_path: window.location.pathname,
    referrer: document.referrer || "",
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_term: params.get("utm_term") || "",
    utm_content: params.get("utm_content") || "",
    device: detectDevice(),
    browser: navigator.userAgent.slice(0, 120),
  };
  if (!existing) sessionStorage.setItem(ATTR_KEY, JSON.stringify(ctx));
  return ctx;
}

function send(events) {
  const body = JSON.stringify({
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    context: captureContext(),
    events,
  });
  const url = `${API}/track/collect`;
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
      return;
    }
  } catch { /* fall through */ }
  fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
}

export function trackPageView(path, title) {
  send([{ type: "page_view", path: path || window.location.pathname, title: title || document.title, ts: new Date().toISOString() }]);
}

export function trackEvent(type, meta = {}) {
  send([{ type, path: window.location.pathname, title: document.title, ts: new Date().toISOString(), meta }]);
}

export function getAttribution() {
  return { session_id: getSessionId(), visitor_id: getVisitorId() };
}

// Engagement/time-on-site tracking: sends a heartbeat while the tab is visible
// (and the visitor is active) so session duration reflects real time spent.
// Powers the lead "Average Time Spent" and "Visitor Score".
let _hbTimer = null;
let _lastActive = Date.now();

function markActive() { _lastActive = Date.now(); }

export function initEngagementTracking() {
  if (_hbTimer || typeof window === "undefined") return;
  ["mousemove", "keydown", "scroll", "click", "touchstart"].forEach((e) =>
    window.addEventListener(e, markActive, { passive: true }));
  _hbTimer = setInterval(() => {
    if (document.visibilityState !== "visible") return;
    if (Date.now() - _lastActive > 60000) return; // idle > 60s: skip
    trackEvent("heartbeat");
  }, 20000);
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") markActive(); });
}
